module.exports = __webpack_public_path__ + "static/media/BiographyofaStreet.3c92a707.png";


//////////////////
// WEBPACK FOOTER
// ./src/PortfolioImages/BiographyofaStreet.png
// module id = 100
// module chunks = 0